import r from"./typeof.js";import t from"./toPrimitive.js";function o(o){var i=t(o,"string");return"symbol"===r(i)?i:String(i)}export{o as default};
//# sourceMappingURL=toPropertyKey.js.map
